import { UserOutlined } from '@ant-design/icons';
import { formatUserRole } from '@/constants/roles';
import { useAuthStore } from '@/stores/auth.store';

export function LeaderProfilePage() {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return null;
  }

  const items = [
    { label: '姓名', value: user.name },
    { label: '手机号', value: user.phone },
    { label: '账号类型', value: formatUserRole(user.role) },
    { label: '部门 ID', value: user.departmentId },
  ];

  return (
    <div>
      <div className="mobile-profile-hero">
        <div className="mobile-mine-avatar">
          <UserOutlined />
        </div>
        <div className="mobile-mine-name">{user.name}</div>
      </div>
      <div className="mobile-menu-list">
        {items.map((item) => (
          <div key={item.label} className="mobile-menu-item" style={{ cursor: 'default' }}>
            <span style={{ color: '#888' }}>{item.label}</span>
            <span>{item.value}</span>
          </div>
        ))}
      </div>
      <p className="mobile-hint">如需修改姓名、部门等信息，请联系系统管理员。</p>
    </div>
  );
}
